/**
 * Read at init rather than cached at module load, so a viewer who changes the
 * OS setting mid-session gets the new behaviour on the next banner mounted.
 */
const prefersReducedMotion = () =>
	window.matchMedia('(prefers-reduced-motion: reduce)').matches;

window.HomeHeroBanner = (words = []) => {
	return {
		words,
		index: 0,
		animate: true,

		// Append a clone of the first word so we can loop seamlessly:
		// sliding onto the clone looks identical to the first word, then we
		// reset back to index 0 with the animation off (invisible jump).
		get loopWords() {
			return this.words.length ? [...this.words, this.words[0]] : this.words;
		},

		// How far to slide the stack up, as a % of its own height (one word per step).
		get offset() {
			return this.loopWords.length ? (this.index / this.loopWords.length) * 100 : 0;
		},

		init() {
			// Reduced motion stops the rotation outright rather than swapping
			// words instantly: this auto-plays, loops forever and has no pause
			// control, so a hard cut every 2s would still be exactly the
			// auto-updating motion the setting is asking us not to do. The
			// first word stays put, which is the same word the <h1> announces.
			if (this.words.length > 1 && !prefersReducedMotion()) {
				setInterval(() => this.next(), 2000);
			}
		},

		next() {
			this.animate = true;
			this.index++;

			// We just slid onto the appended clone of the first word.
			if (this.index === this.words.length) {
				setTimeout(() => {
					this.animate = false; // turn off the transition for the reset
					this.index = 0;       // jump back to the real first word
				}, 500); // keep in sync with duration-500 below
			}
		},
	};
};
